import { initializeApp, getApps } from 'firebase/app';
import { getRemoteConfig, RemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';

// Initialize Firebase with config from environment variables
// Uses REACT_APP_FIREBASE_REMOTE_CONFIG for Remote Config
const firebaseConfig = process.env.REACT_APP_FIREBASE_REMOTE_CONFIG
  ? JSON.parse(process.env.REACT_APP_FIREBASE_REMOTE_CONFIG)
  : {
      apiKey: '',
      authDomain: '',
      projectId: '',
      storageBucket: '',
      messagingSenderId: '',
      appId: '',
    };

// Debug: Verify config is loaded correctly
console.log('Firebase Remote Config loaded:', {
  hasProjectId: !!firebaseConfig.projectId,
  projectId: firebaseConfig.projectId || 'MISSING',
  hasAppId: !!firebaseConfig.appId,
});

// Initialize a separate Firebase app for Remote Config (not the default app)
// This allows different Firebase projects for Storage and Remote Config
const remoteConfigApp = initializeApp(firebaseConfig, 'remoteConfig');
const remoteConfig: RemoteConfig = getRemoteConfig(remoteConfigApp);

// Set default values for development
remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour
remoteConfig.settings.fetchTimeoutMillis = 60000; // 1 minute

// Set default values
remoteConfig.defaultConfig = {
  wa_mx: '55 1079 0688',
  wa_co: '+57 310 769 9490',
  wa_us: '(210) 878-7819',
  wa_es: '+1(210) 878-7819',
};

/**
 * Fetch and activate Remote Config parameters
 * This should be called once at app initialization
 */
export const initializeRemoteConfig = async (): Promise<void> => {
  try {
    await fetchAndActivate(remoteConfig);
    console.log('Remote Config initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Remote Config:', error);
  }
};

/**
 * Get a value from Remote Config
 * @param key - The parameter key
 * @returns The parameter value as string
 */
export const getRemoteConfigValue = (key: string): string => {
  try {
    return getValue(remoteConfig, key).asString();
  } catch (error) {
    console.error(`Failed to get Remote Config value for key ${key}:`, error);
    return '';
  }
};

/**
 * Get WhatsApp number for Mexico from Remote Config
 */
export const getWaMx = (): string => {
  return getRemoteConfigValue('wa_mx');
};

/**
 * Get WhatsApp number for Colombia from Remote Config
 */
export const getWaCo = (): string => {
  return getRemoteConfigValue('wa_co');
};

/**
 * Get WhatsApp number for USA from Remote Config
 */
export const getWaUs = (): string => {
  return getRemoteConfigValue('wa_us');
};

/**
 * Get WhatsApp number for Spain from Remote Config
 */
export const getWaEs = (): string => {
  return getRemoteConfigValue('wa_es');
};

export default remoteConfig;
